import i18next from 'i18next';
import React, { FC } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import AppModal from './app-modal/AppModal';

type Props = {
  show: boolean;
  sent: boolean;
  onPositive: () => void;
  onNegative: () => void;
};

export const EmailValidationModal: FC<Props> = ({ show, sent, onPositive, onNegative }) => {
  return (
    <AppModal show={show} onHide={() => onNegative()}>
      <Modal.Header closeButton>
        <Modal.Title>{i18next.t('emailValidationModal.title')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {i18next.t('emailValidationModal.body')}
        <br />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="link" onClick={() => onNegative()}>
          {i18next.t('generic.cancel')}
        </Button>
        {sent ? (
          <span>{i18next.t('emailValidationModal.sentInfo')}</span>
        ) : (
          <Button variant="link" onClick={() => onPositive()}>
            {i18next.t('emailValidationModal.resend')}
          </Button>
        )}
      </Modal.Footer>
    </AppModal>
  );
};

export default EmailValidationModal;
